import { connect } from 'react-redux'
import App from './App'
import authSelector from 'modules/Auth/selectors'
import { getStudentData } from './modules/Onboarding/actions'
import { SignIn } from './modules/Auth/actions'
import selectors from 'modules/Onboarding/selectors'

const mapStateToProps = state => ({
  token: authSelector.getToken(state),
  studentData: selectors.getStudentResumeData(state),
  studentDetails: selectors.getStudentEditData(state),
})

const mapDispatchToProps = {
  getStudentData,
  SignIn,
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
